import { purgeNavigationState } from '../navigation/sessionHooks';

export interface AppLogoutDetail {
  reason: string;
  endpoint?: string;
}

declare const logoutNavigationPurgeProofBrand: unique symbol;
export type LogoutNavigationPurgeProof = {
  readonly [logoutNavigationPurgeProofBrand]: true;
};

const navigationPurgedEvents = new WeakSet<Event>();
const proofByEvent = new WeakMap<Event, LogoutNavigationPurgeProof>();
const validProofs = new WeakSet<object>();

function proofForEvent(event: Event): LogoutNavigationPurgeProof {
  const existing = proofByEvent.get(event);
  if (existing) return existing;
  const proof = Object.freeze({}) as LogoutNavigationPurgeProof;
  proofByEvent.set(event, proof);
  validProofs.add(proof);
  return proof;
}

export function dispatchLogoutAfterAuthClear(
  clearAuth: () => void,
  detail: AppLogoutDetail,
): void {
  clearAuth();
  if (typeof window === 'undefined' || typeof CustomEvent === 'undefined') return;
  try {
    const event = new CustomEvent<AppLogoutDetail>('app:logout', { detail });
    navigationPurgedEvents.add(event);
    window.dispatchEvent(event);
  } catch {
    // Auth and navigation state are already cleared; logout continues fail-closed.
  }
}

export function ensureLogoutNavigationPurge(event: Event): LogoutNavigationPurgeProof {
  if (!navigationPurgedEvents.has(event)) {
    purgeNavigationState('logout');
    navigationPurgedEvents.add(event);
  }
  return proofForEvent(event);
}

export function consumeLogoutNavigationPurgeProof(
  proof: LogoutNavigationPurgeProof | undefined,
): boolean {
  if (!proof || !validProofs.has(proof)) return false;
  validProofs.delete(proof);
  return true;
}
